import React, { FC } from 'react';
import { Container, Line } from './Divider.styled';
import { isDividerElement } from 'utils/typeGuards';
import { DraggableComponentProps } from 'features/document/constants';

const Divider: FC<DraggableComponentProps> = ({ currentElement }) => {
  if (!isDividerElement(currentElement)) {
    return null;
  }

  const { thickness, color, borderRadius, size } = currentElement.style;
  return (
    <Container>
      <Line color={color} thickness={thickness} borderRadius={borderRadius} size={size} />
    </Container>
  );
};

export default Divider;
